import { IntlShape, MessageDescriptor } from 'react-intl'

type FormatValues = Record<string, string | number | boolean | null | undefined>

let activeIntl: IntlShape | null = null

export const IntlService = {
  setIntl(intl: IntlShape) {
    activeIntl = intl
  },
  formatMessage(descriptor: MessageDescriptor, values?: FormatValues): string {
    if (activeIntl) {
      return activeIntl.formatMessage(descriptor, values as any)
    }
    // Fallback to the defaultMessage if intl isn't ready yet — keeps the app
    // from crashing if an epic fires a toast before IntlProvider mounts.
    return (descriptor.defaultMessage as string) || (descriptor.id as string) || ''
  },
}
